import { Typography } from "@mui/material";
import { store } from "../../../..";
import { getTemplateGridNavigationItem } from "../QuestionnaireTemplate/utils";
import { QuestionnaireItemType } from "../../../../_helpers";

const getCurrentTemplate = () => {
  const state = store.getState();
  const { templateDetails } = state?.questionnaireStore?.questionnaireTemplateDetails || {};
  const latestVersionNumber = Math.max(...Object.values(templateDetails).map(v => v.version));
  return templateDetails?.[latestVersionNumber] || null;
};

const getGeneralSettings = (t) => {
   const data = getCurrentTemplate()
    return [
        {
            title: t('general.template'),
            value: data?.name || ''
        },
        {
            title: t('general.description'),
            value: data?.description || ''
        },
        {
            title: t('general.version'),
            value: data?.version || '' 
        },
         {
            title: t('questionnaire.reportHeader'),
            value: data?.reportHeader || '' 
        },
        {
            title: t('general.active'),
            value: <Typography variant='caption' color={data?.active ? "success" : "error"}>{data?.active ?  t("general.yes") :  t("general.no")}</Typography> || ''
        }
    ]
}
const getQuestionsInfo = (t) => {
       const data = getCurrentTemplate()
      const totalQuestions = data?.sections?.reduce(
        (count, section) => count + (section?.questions?.length || 0),
        0
    );
    return [
        {
            title: t('questionnaire.numberOfQuestions'),
            value: totalQuestions 
        },
    ]

}
export const getGeneralSettingsInfo = (t)=> [
    {
        title:t('general.general'),
        type: 'template',
        details: getGeneralSettings(t),
        isHiddenEditIcon: true,
        isHiddenCheckBox: true,
        isDisabled: false
    },
     {
        id: "template",
        type: "template",
        details: getQuestionsInfo(t),
        isHiddenEditIcon: false,
        isPreviewDisplay: true,
    },
]
export const getQuestionnaireTemplateDetailNavigationItem = (t)=>{
     const data = getCurrentTemplate()
    const taskAutomationNavigationItems = getTemplateGridNavigationItem(t)
    const breadCrumbTitle = `v${data?.version} - ${data?.name}`;
    const to = "/vragenlijst-sjabloon"+data?.id 
    return {
        breadCrumbs: [ ...taskAutomationNavigationItems?.breadCrumbs , { title: t("general.template") + " - " +breadCrumbTitle, breadCrumbTitle : breadCrumbTitle , to}],
        tabs: [...taskAutomationNavigationItems?.tabs ,{ title: t('general.form') , to}]        
    }
}



export const getFormQuestionsSubmitPayload = (sections)=>{
    return sections.map((section, sectionIndex)=>{
        return {
            ...section,
            id:"",
            questions: section.questions.map((question, questionIndex)=>{
                return {
                    ...question,
                    id:"",
                    ...[QuestionnaireItemType.Checkbox,QuestionnaireItemType.Radio , QuestionnaireItemType.Dropdown].includes(question.type) ? {
                        options: question.options.map((option, optionIndex)=>{
                            return {...option, order: optionIndex + 1 , id:""}
                        })
                    } : {},
                    order: questionIndex + 1
                }
            }),
            order : sectionIndex + 1,
        }
    })
}

export const createRenderSections = (sections) => {
  return sections.map((sec) => ({
    title: sec.title || "",
    description: sec.description || "",
    questions: sec.questions.map((q) => ({
      text: q.text || "",
      type: q.type,
      freeTextSize: q.freeTextSize,
      required: q.required,
      allowFiles: q.allowFiles,
      options:
        [QuestionnaireItemType.Radio,QuestionnaireItemType.Checkbox,QuestionnaireItemType.Dropdown,].includes(q.type) 
          ? q.options.map((op) => ({
              option: op.option,
            }))
          : [],

    })),
  }));
};


export const validateQuestionnaireQuestionForm = (sections,t)=>{
    let errors = {
     
    };

    sections.forEach((section, sectionIndex)=>{
        if(!section.title || !section.description){
            errors = {
                ...errors,
                [`${sectionIndex}`] : t("questionnaire.form.sectionTitleDescription.errorText")
            }
        }

        section.questions.forEach((question, questionIndex)=>{
            switch (question.type) {
                case QuestionnaireItemType.Checkbox:
                case QuestionnaireItemType.Dropdown:
                case QuestionnaireItemType.Radio:

                    if(!question.text){
                        errors = {...errors , [`${sectionIndex}-${questionIndex}`] : t(`questionnaire.form.error.questionTextRequired`)}
                        return
                    }

                    if(question.required && question.options.length < 2 ){
                        errors = {...errors , [`${sectionIndex}-${questionIndex}`] : t(`questionnaire.form.error.atLeastTwoOptionsAreRequired`)}
                        return
                    }
                    
                    break;
                case QuestionnaireItemType.Date:
                case QuestionnaireItemType.FreeText:
                case QuestionnaireItemType.Paragraph:
                case QuestionnaireItemType.ShortText:
                case QuestionnaireItemType.Signature:
                case QuestionnaireItemType.Time:
                if(!question.text){
                        errors = {...errors , [`${sectionIndex}-${questionIndex}`] : t(`questionnaire.form.error.questionTextRequired`)}
                        return
                    }

                  break
                default:
                    break;
                    
            }
        })
    })

    return errors
}
